/**
 * Controls the display of the floating contact form.
 */
function tarjet_form(){
    if(!!document.querySelector('.contact_btn__btn')){
        let btn_contact = document.querySelector('.contact_btn__btn');

        btn_contact.addEventListener('click', e => {
            e.preventDefault();
            
            let float_form = document.querySelector('.float_form');

            float_form.classList.toggle("form_visible");
            
            if(float_form.classList.contains("form_visible")){
                float_form.style.display = 'flex';
            }else{
                float_form.style.display = 'none';
            }
            
        });
    }
}

tarjet_form();

export default tarjet_form;